import { Link } from "react-router-dom";
import heroImg from "@/assets/hero-sticker.jpg";
import { useTranslation } from "react-i18next";
import QuickQuote from "@/components/home/QuickQuote";


const HeroSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[50vh] md:min-h-[75vh] flex items-start overflow-hidden">
      <div className="absolute inset-0">
        <img src={heroImg} alt="Naklejki wypukłe 3D zalewane żywicą poliuretanową – produkcja premium doming w Polsce" className="w-full h-full object-cover" width={1920} height={1080} fetchPriority="high" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy-dark/95 via-navy/80 to-navy-dark/60" />
      </div>

      <div className="container mx-auto px-4 relative z-10 pt-8 md:pt-14 pb-12 md:pb-20">
        <div className="grid lg:grid-cols-[1.15fr_0.85fr] gap-8 lg:gap-12 items-start">
        <div className="max-w-3xl text-center lg:text-left">
          <div className="inline-block gradient-gold text-accent-foreground text-[10px] md:text-xs font-semibold px-3 md:px-4 py-1 md:py-1.5 rounded-full mb-4 md:mb-6 animate-fade-in-up">
            {t("hero.badge")}
          </div>
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 md:mb-6 animate-fade-in-up" style={{ animationDelay: "0.1s" }}>
            <span className="text-primary-foreground">{t("hero.title1")}</span>
            <span className="text-gradient-gold">{t("hero.titleGold")}</span>
            <span className="text-primary-foreground">{t("hero.title2")}</span>
          </h1>
          <h2 className="text-base md:text-2xl font-semibold text-primary-foreground/90 mb-3 md:mb-4 animate-fade-in-up" style={{ animationDelay: "0.15s" }}>
            {t("hero.heroSubtitle")}
          </h2>
          <p className="text-sm md:text-base text-primary-foreground/70 mb-4 md:mb-6 leading-relaxed max-w-2xl animate-fade-in-up" style={{ animationDelay: "0.2s" }}>
            {t("hero.heroDescription")}
          </p>
          <p className="text-sm md:text-xl text-primary-foreground/80 mb-6 md:mb-8 leading-relaxed max-w-2xl animate-fade-in-up" style={{ animationDelay: "0.25s" }}>
            {t("hero.desc")}
          </p>
          <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-3 md:gap-4 animate-fade-in-up" style={{ animationDelay: "0.3s" }}>
            <Link
              to="/kalkulator"
              className="gradient-gold text-accent-foreground font-bold px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg hover:opacity-90 transition-opacity shadow-gold text-center"
              aria-label="Wyceń naklejki 3D online – kalkulator cen"
            >
              {t("hero.cta")}
            </Link>
            <Link
              to="/produkty"
              className="border-2 border-primary-foreground/30 text-primary-foreground font-semibold px-6 md:px-8 py-3 md:py-4 rounded-lg text-base md:text-lg hover:border-accent hover:text-accent transition-colors text-center"
              aria-label="Zobacz pełną ofertę naklejek 3D doming"
            >
              {t("hero.products")}
            </Link>
          </div>
        </div>
        <div className="w-full max-w-md mx-auto lg:mx-0">
          <QuickQuote />
        </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
